const messages = {
  title: "Listini prezzi e brochure prodotto",
  title_media: "Listini prezzi e brochure prodotto",
  description:
    "Scarica qui gli ultimi volantini e le brochure sui pneumatici Bridgestone e Firestone per auto, SUV e veicoli commerciali leggeri.",
  short_description:
    "Qui puoi trovare risorse per social media, TV in-store e altro.",
  mediaCategories: {
    products: "Prodotti",
    brand_and_solutions: "Marca e soluzioni",
    season_and_promotions: "Stagione e promozioni",
    format: "Formato",
    cars_and_vans: "Auto, SUV, veicolo commerciale",
    truck_and_buses: "Autocarro e autobus",
    motorcycle: "Moto",
    agriculture: "Agricoltura",
    construction_machinery: "Macchine movimento terra",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiali",
    brochures: "Brochure prodotto",
    price_list: "Listini prezzi",
    materials: "Materiali",
    video_in_store: "Video con sottotitoli",
    video_online: "Video senza sottotitoli",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Social media",
    logos: "Loghi",
    summer: "Estate",
    winter: "Inverno",
    all_season: "Tutte le stagioni",
    promotions: "Promozioni",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIATECA",
    description:
      "Benvenuti nella sezione media dedicata   \n" +
      "ai prodotti Bridgestone e Firestone.  \n <br> <br>" +
      "Scoprirete immagini di prodotti,   \n" +
      "loghi, nonché un'ampia selezione di   \n" +
      "banner, video e materiali digitali   \n" +
      "da utilizzare sul vostro sito web o sui   \n" +
      "social media.  ",
    bDrive: {
      title: "Foto prodotti",
      description:
        "Le immagini attuali   \n" +
        "possono essere scaricate   \n" +
        "dal nostro portale B-\n" +
        "DRIVE.  ",
    },
  },
  buttons: {
    media: "SCOPRI",
  },
  searchMedia: "Inserisci una parola chiave",
  searchResults: "Risultati di ricerca",
};

export default {
  messages,
};
